<template>
    <div class="inline-block" :name="instanceId">
        <section class="is-flex">
            <b-checkbox v-model="isTermsAccepted">I agree to the <a href="#" @click="isTermsModalActive = true">terms and conditions</a> </b-checkbox>
        </section>
        <b-modal :active.sync="isTermsModalActive" :width="640" scroll="keep" :has-modal-card="true" :canCancel="false" v-if="isTermsModalActive">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                <p class="modal-card-title">Terms and Conditions</p>
                </header>
                <section class="modal-card-body">
                    <div class="columns">
                        <div class="column has-text-left">
                        <p>By clicking 'Accept', you submit and certify the accuracy of the information provided in this form, and that you are at least 18 years old.</p>
                        <br>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                <button class="button is-info" @click="closeTermsAndConditions">Accept</button>
                </footer>
            </div>
        </b-modal>
    </div>
  </template>

<script>

export default {
  name: 'GenericTermsControl',
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      instanceId: this.$uuid.v4(),
      isTermsModalActive: false,
      isTermsAccepted: this.value
    }
  },
  computed: {
  },
  methods: {
    closeTermsAndConditions () {
      this.isTermsModalActive = false
    }
  },
  watch: {
    isTermsAccepted: function (newValue, oldValue) {
      this.$emit('input', newValue)
    },
    value: function (newValue, oldValue) {
      this.isTermsAccepted = newValue
    }
  },
  mounted: function () {
  },
  beforeDestroy () {
  },
  updated: function () {
  }
}
</script>
